<template>
  <v-app>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>درباره ما</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.fullname"
                        label="نام"
                        reverse
                        class="text-left"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.email"
                        label="ایمیل"
                        reverse
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.subject"
                        label="موضوع"
                        reverse
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  لغو کردن
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  ذخیره کردن
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >آیا میخواهید این آیتم را حذف کنید؟</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >لغو کردن</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >تایید کردن</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <img :src="item.image" height="70" width="100" alt="" />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          large
          class="mr-2 deep-purple--text accent-1"
          color="white--text"
          @click="getUser(item)"
        >
          mdi-pencil
        </v-icon>
        <!-- <v-icon large class="pink--text accent-3" @click="deleteItem(item)"> mdi-delete </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> ریکوردی یافت نشد </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  data: () => ({
    id: null,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "تصویر",
        align: "start",
        sortable: false,
        value: "image",
      },
      {
        text: "عنوان",
        align: "start",
        sortable: false,
        value: "title",
      },
      { text: "تنظیمات", value: "actions", sortable: false, align: "left" },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      fullname: "",
      subject: "",
      email: "",
    },
    defaultItem: {
      fullname: "",
      subject: "",
      email: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "آیتم جدید" : "ویرایش";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapMutations(["setArticleInfo"]),
    async getUser() {
      this.$router.push(`/static-management/about-us-edit`);
    },
    async initialize() {
      axios
        .get(`http://api.karaclub.com/api/Aboutus/Get`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          this.setArticleInfo(response.data.data);
          this.desserts.push({
            title: response.data.data.title,
            image: response.data.data.image,
          });
        });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.id = item.id;
    },

    async deleteItemConfirm() {
      await axios
        .put(
          `http://api.karaclub.com/api/User/ToggleAllowComment?id=${this.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.desserts.splice(this.editedIndex, 1);
          this.closeDelete();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>
<style >
.v-application .text-h5 {
  font-family: "iransans", "yekan", "vazir" !important;
}
</style>